import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BackendService } from '../../../core/services/backend/backend.service';
import { tap } from 'rxjs';

interface INGame{
  name: string,
  password: string,
  password_required: boolean,
  maximum_players: number
}

@Injectable({
  providedIn: 'root'
})
export class NewGameService {
  http = inject(HttpClient)
  backend = inject(BackendService)

  constructor() { }

  createNewGame(sendValue: INGame){
    return this.http.post(`${this.backend.getApiUrl()}/rooms`, sendValue);
  }
}
